import { supabase } from '../supabase';
import { v4 as uuidv4 } from 'uuid';
import imageCompression from 'browser-image-compression';

async function compress(file, maxSizeMB = 1, maxWidthOrHeight = 1920) {
  try {
    return await imageCompression(file, { maxSizeMB, maxWidthOrHeight, useWebWorker: true });
  } catch {
    return file; // fall back to original if compression fails
  }
}

export const uploadCustomerPhoto = async (sessionId, file) => {
  const compressed = await compress(file, 0.8, 1920);
  const ext = file.name.split('.').pop();
  const path = `${sessionId}/${uuidv4()}.${ext}`;
  const { error } = await supabase.storage.from('customer-uploads').upload(path, compressed, { upsert: false });
  if (error) throw error;
  const { data } = supabase.storage.from('customer-uploads').getPublicUrl(path);
  return { url: data.publicUrl, path };
};

export const uploadJobPhoto = async (bookingId, phase, file) => {
  const compressed = await compress(file, 1.5, 2048);
  const ext = file.name.split('.').pop();
  const path = `${bookingId}/${phase}/${uuidv4()}.${ext}`;
  const { error } = await supabase.storage.from('job-photos').upload(path, compressed);
  if (error) throw error;
  const { data } = supabase.storage.from('job-photos').getPublicUrl(path);
  return { url: data.publicUrl, path };
};

export const deleteJobPhoto = async (path) => {
  const { error } = await supabase.storage.from('job-photos').remove([path]);
  if (error) throw error;
};

export const uploadGalleryPhoto = async (file) => {
  const ext = file.name.split('.').pop();
  const path = `${uuidv4()}.${ext}`;
  const { error } = await supabase.storage.from('gallery').upload(path, file);
  if (error) throw error;
  const { data } = supabase.storage.from('gallery').getPublicUrl(path);
  return { url: data.publicUrl, path };
};
